import Vue from 'vue';
import VueRouter from 'vue-router';
import ConsultaJurisprudenciaSelecionadaRoutes from '@/views/jurisprudencia-selecionada/router';
import ConsultaBoletinsRoutes from '@/views/boletins/router';
import LegislacaoNormasRoutes from '@/views/legislacao/router';
import ParecerRoutes from '@/views/parecer/router';
import ConsultaObrasRoutes from '@/views/obras/router';
import ParecerReferencialRoutes from '@/views/parecer-referencial/router';
import PublicoParecerReferencialRoutes from '@/views/publico-parecer-referencial/router';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ConsultaJurisprudenciaSelecionadaRoutes,
    ConsultaBoletinsRoutes,
    LegislacaoNormasRoutes,
    ParecerRoutes,
    ConsultaObrasRoutes,
    ParecerReferencialRoutes,
    PublicoParecerReferencialRoutes,
  ].flat(1),
});

router.afterEach(() => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
});

export default router;
